export default __webpack_public_path__ + "static/media/logo.84554c10.svg";